var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQobuz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4329 19.6565C16.6941 21.119 14.4499 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.4697 21.1047 16.7303 19.621 18.4749L21.8856 20.7444L20.6972 21.8705L18.4329 19.6565Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 14.4269 21.6761 16.6625 20.2932 18.4407L22.6019 20.7545L20.6918 22.5644L18.4006 20.3242C16.6289 21.6884 14.4087 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12ZM12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.7533 21.5 12 21.5C14.3278 21.5 16.459 20.6634 18.1111 19.2739L18.4582 18.9819L20.7027 21.1765L21.1692 20.7344L18.9416 18.5019L19.2401 18.151C20.6498 16.4934 21.5 14.3466 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 3.94568C7.55159 3.94568 3.94629 7.55177 3.94629 11.999C3.94629 16.4463 7.55238 20.0532 11.9996 20.0532C16.4469 20.0532 20.053 16.4471 20.053 11.999C20.053 7.55098 16.4477 3.94568 11.9996 3.94568ZM11.9996 15.1672C10.2502 15.1672 8.83148 13.7484 8.83148 11.999C8.83148 10.2496 10.2502 8.83087 11.9996 8.83087C13.749 8.83087 15.1678 10.2496 15.1678 11.999C15.1678 13.7492 13.7498 15.1672 11.9996 15.1672Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.687C12.3794 12.687 12.6871 12.3792 12.6871 11.9997C12.6871 11.6201 12.3794 11.3124 11.9998 11.3124C11.6202 11.3124 11.3125 11.6201 11.3125 11.9997C11.3125 12.3792 11.6202 12.687 11.9998 12.687Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14947 11.8357C8.23548 9.78247 9.92647 8.14434 12.0002 8.14434C14.0739 8.14434 15.7657 9.78247 15.8509 11.8357H19.4388C19.3512 7.80109 16.056 4.5564 12.0002 4.5564C7.94431 4.5564 4.64832 7.80109 4.56152 11.8357H8.14947Z",
    fill: "url(#paint0linear3042169)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.55786V8.1458C14.0745 8.17184 15.8026 9.83601 15.8531 11.905H19.441C19.3905 7.85463 16.0567 4.5839 12 4.55786Z",
    fill: "url(#paint1linear3042169)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 4.55786V8.1458C9.92568 8.17184 8.19918 9.83601 8.14947 11.905H4.56152C4.61202 7.85463 7.94431 4.5839 12.0002 4.55786Z",
    fill: "url(#paint2linear3042169)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3036 18.0579C15.8865 19.2991 14.0321 20.0534 12.0002 20.0534C11.9923 20.0534 11.9845 20.0527 11.9766 20.0527V21.9993C11.9845 21.9993 11.9923 22.0001 12.0002 22.0001C14.5206 22.0001 16.8215 21.0658 18.5804 19.5271C18.1582 19.0332 17.7187 18.555 17.3036 18.0579Z",
    fill: "url(#paint3linear3042169)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8851 20.7444L16.4902 15.3376C16.3308 15.1269 16.079 14.9896 15.795 14.9896C15.3136 14.9896 14.9238 15.3794 14.9238 15.8608C14.9238 16.0951 15.0169 16.3074 15.1677 16.4644C15.1779 16.4747 15.1882 16.4849 15.1992 16.4952L20.6967 21.8704L21.8851 20.7444Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0linear3042169",
    x1: 4.56168,
    y1: 8.1961,
    x2: 19.4395,
    y2: 8.1961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8763
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1linear3042169",
    x1: 11.7681,
    y1: 5.14691,
    x2: 17.6012,
    y2: 10.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#B5B5B5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1244,
    stopColor: "#969696",
    stopOpacity: 0.1632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    stopColor: "#2B2B2B",
    stopOpacity: 0.7421
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2linear3042169",
    x1: 12.2334,
    y1: 5.14746,
    x2: 6.40102,
    y2: 10.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#B5B5B5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1244,
    stopColor: "#969696",
    stopOpacity: 0.1632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    stopColor: "#2B2B2B",
    stopOpacity: 0.7421
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3linear3042169",
    x1: 12.9317,
    y1: 21.4324,
    x2: 18.3897,
    y2: 17.7147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#B5B5B5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0486,
    stopColor: "#A8A8A8",
    stopOpacity: 0.0514
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2682,
    stopColor: "#6C6C6C",
    stopOpacity: 0.2982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4701,
    stopColor: "#3E3E3E",
    stopOpacity: 0.5252
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6478,
    stopColor: "#1C1C1C",
    stopOpacity: 0.725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7947,
    stopColor: "#070707",
    stopOpacity: 0.8901
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8925
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQobuz);
export default __webpack_public_path__ + "static/media/qobuz.fd05c4c4.svg";
export { ForwardRef as ReactComponent };